import React, { Component } from 'react';
import { Redirect } from 'react-router';
import axios from "axios";
import ApiURL from "../../api/ApiURL";
import cogoToast from 'cogo-toast';
import LocalStorageHelper from '../../LocalStorageHelper/LocalStorageHelper';
import loginImage from '../../assets/images/login.jpg';
import validation from '../../validation/validation';
import { Link } from 'react-router-dom';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            btnResetPassword: "Reset Password",
            custUserId: 0,
            userId: 0,
            regEmail: '',
            oldRegPwd: '',
            regPwd: '',
            confirmPwd: '',
            redirectToLogin: false,
        }
    }

    componentDidMount() {
        /* Get User Profile Data */
        var userData = JSON.parse(LocalStorageHelper.getUser());
        if (userData !== null) {
            this.setState({
                custUserId: userData.UserId,
                userId: userData.UserId,
                regEmail: userData.Email
            })
        }
    }

    onChangeHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    resetPassword = (e) => {
        e.preventDefault();
        if (this.state.custUserId === 0 && this.state.regEmail === '') {
            cogoToast.error('Registered email is required!', { position: 'bottom-center' });
        }
        else if (this.state.regPwd === '') {
            cogoToast.error('Old password is required!', { position: 'bottom-center' });
        }
        else if (this.state.regPwd !== this.state.confirmPwd) {
            cogoToast.error('Registered password does not match with confirm password!', { position: 'bottom-center' });
        }
        else {
            this.setState({ btnResetPassword: "Processing..." })
            var webApiUrl = '';
            var param = {};
            if (this.state.custUserId === 0) {
                webApiUrl = ApiURL.ForgotPassword;
                param = {
                    Email: this.state.regEmail,
                    Pwd: this.state.regPwd,
                    UserId: this.state.userId,
                };
            }
            else {
                webApiUrl = ApiURL.ResetPassword;
                param = {
                    CustomerUserId: this.state.custUserId,
                    OldPwd: this.state.oldRegPwd,
                    Pwd: this.state.regPwd,
                    UserId: this.state.userId,
                };
            }

            axios.post(webApiUrl, param).then(response => {
                let respData = response.data;
                if (respData.StatusCode === 200) {
                    cogoToast.success(respData.Message, { position: 'bottom-center' });
                }
                else if (respData.StatusCode === 400) {
                    cogoToast.warn(respData.Message, { position: 'bottom-center' });
                }
                else if (respData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: 'bottom-center' });
                }

            }).catch(error => {
                cogoToast.error("Password change request failed! Please Try Again.", { position: 'bottom-center' })
            })

            //Clear for fields
            this.clearFormFields();

        }
    }

    clearFormFields = () => {
        this.setState({
            btnResetPassword: "Reset Password",
            regEmail: '',
            oldRegPwd: '',
            regPwd: '',
            confirmPwd: ''
        })
    }

    render() {
        return (
            <>
                <div class="container">
                    <div class="min-vh-100 d-flex align-items-center">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-10 mx-auto">
                                    <div class="shadow-lg">
                                        <div class="d-flex align-items-center">
                                            <div class="d-none d-md-block d-lg-block">
                                                <img src={loginImage} alt="..." />
                                            </div>
                                            <div class="col-md-5 col-12 col-lg-5">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="boxLogin">
                                                            <h2>Change Password</h2>
                                                            <form>
                                                                {
                                                                    (this.state.custUserId === 0) ?
                                                                        <div className="inputBox">
                                                                            <input type="text" name="regEmail" value={this.state.regEmail} onChange={this.onChangeHandler} autoComplete={0} />
                                                                            <label><i className="fa fa-envelope"></i> Email *</label>
                                                                        </div>
                                                                        :
                                                                        <div className="inputBox">
                                                                            <input type="password" name="oldRegPwd" value={this.state.oldRegPwd} onChange={this.onChangeHandler} />
                                                                            <label><i className="fa fa-eye"></i> Old Password *</label>
                                                                        </div>
                                                                }
                                                                <div className="inputBox">
                                                                    <input type="password" name="regPwd" value={this.state.regPwd} onChange={this.onChangeHandler} />
                                                                    <label><i className="fa fa-eye"></i> New Password *</label>
                                                                </div>
                                                                <div className="inputBox">
                                                                    <input type="password" name="confirmPwd" value={this.state.confirmPwd} onChange={this.onChangeHandler} />
                                                                    <label><i className="fa fa-eye"></i> Confirm Password *</label>
                                                                </div>
                                                                <button className="btn btn-dark px-4" onClick={this.resetPassword}><i className="fa fa-asterisk"></i> {this.state.btnResetPassword}</button>&nbsp;
                                                                <Link className="btn btn-dark px-4" to={"/login"}><i className="fa fa-key"></i> Login</Link>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>
        );
    }
}

export default ForgotPassword;